export const CODE_SUGGESTIONS_EXTENSION_KEY = 'codesuggestions:suggestion-node';
export const CODE_SUGGESTIONS_EXTENSION_TYPE =
  'com.atlassian.bbc.code-suggestions';
